/*=========================================================================================
  File Name: moduleCategoryManagement.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/Category/pixinvent
==========================================================================================*/


import state from './moduleCategoryManagementState.js'
import mutations from './moduleCategoryManagementMutations.js'
import actions from './moduleCategoryManagementActions.js'
import getters from './moduleCategoryManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

